import React, { useEffect, useState } from "react";

import PretendardText from "../../atoms/text/pretendardText";
import MainInput from "../../atoms/input/mainInput";
import Popup from "../../molecules/popup";

import PopupOverLay from "../PopupOverlay";
import TableText from "../../atoms/text/table/tableText";
import SelectBoxValue from "../../organisms/selectBoxValue";
import OrderApi from "../../../api/order.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";

const CancelSalePopup = ({ setPopupOpen, sellData, getSellList }) => {
  // ---------- 취소 사유 관련 ---------- //
  const [reasonBoxOpen, setReasonBoxOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [detail, setDetail] = useState("");

  const reasonList = [
    {
      title: "상품 품절",
      value: "OUT_OF_STOCK",
    },
    {
      title: "서비스 불만족",
      value: "SERVICE_DISSATISFACTION",
    },
    {
      title: "구매의사취소",
      value: "CANCEL_PURCHASE_INTENT",
    },
    {
      title: "상품정보 상이",
      value: "PRODUCT_INFO_MISMATCH",
    },
    {
      title: "다른 상품 잘못 구매",
      value: "WRONG_PRODUCT_PURCHASED",
    },
  ];

  const cancelRequestFunc = async () => {
    try {
      if (selectedReason === "") {
        return toast("취소 사유를 선택해주세요.");
      }

      const data = {
        cancelRequestReason: selectedReason,
        cancelRequestReasonDetail: detail,
      };

      const response = (await OrderApi.updateCancelRequest(sellData.id, data))
        .data.data;

      toast("취소 요청되었습니다.");
      setPopupOpen(false);
      getSellList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          headerTitle="판매취소 처리"
          footerBtnText="확인"
          onClick={() => {
            setPopupOpen(false);
          }}
          footerBtnHandler={() => {
            cancelRequestFunc();
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 32,
            }}
          >
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
              }}
            >
              <colgroup>
                {/* 합계: 630px */}
                {/* 구매번호 */}
                <col width="193px" />
                {/* 상품명 */}
                <col width="326px" />
                {/* 상태*/}
                <col width="111px" />
              </colgroup>
              <thead>
                <tr
                  style={{
                    height: 41,
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th
                    style={{
                      paddingLeft: 30,
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      구매번호
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상품명
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    height: 46,
                  }}
                >
                  <td>
                    <TableText
                      style={{
                        paddingLeft: 30,
                      }}
                    >
                      {sellData.payNumber}
                    </TableText>
                  </td>
                  <td>
                    <TableText>{sellData.orderTitle}</TableText>
                  </td>
                  <td>
                    <TableText>
                      {sellData.orderStatus === "PAY_COMPLETE"
                        ? "결제 완료"
                        : sellData.orderStatus === "CANCEL_REQUEST"
                        ? "취소 요청"
                        : sellData.orderStatus === "CANCEL_REJECT"
                        ? "취소 거절"
                        : sellData.orderStatus === "CANCEL_COMPLETE"
                        ? "취소 완료"
                        : ""}
                    </TableText>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 11,
                padding: "0px 30px",
                marginTop: 30,
              }}
            >
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 15,
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                취소 사유
              </PretendardText>
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 13,
                  lineHeight: "18.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                네이버페이 구매 판매취소의 경우 판매취소 사유를 선택해주셔야
                합니다
              </PretendardText>
              <SelectBoxValue
                placeholder="취소 사유를 선택해주세요"
                selectedValue={selectedReason}
                isOpen={reasonBoxOpen}
                wrapperHandler={() => {
                  setReasonBoxOpen(!reasonBoxOpen);
                }}
                itemList={reasonList}
                selectedValueSetterFunc={setSelectedReason}
              />
              <MainInput
                type={"text"}
                placeholder={"내용을 입력해 주세요."}
                style={{
                  width: "572px",
                }}
                value={detail}
                onChange={(e) => {
                  setDetail(e.target.value);
                }}
              />
            </div>
          </div>
        </Popup>
      </PopupOverLay>
    </>
  );
};

export default CancelSalePopup;
